import styled from 'styled-components';

import { Notice } from '@vimeo/iris/components';

export const NoticeWrapper = styled(Notice)`
  width: unset;
`;
export const NoticeText = styled.span`
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
`;

const StyledNotice = ({ children }: any) => (
  <NoticeWrapper format="primary">
    <NoticeText>{children}</NoticeText>
  </NoticeWrapper>
);

export default StyledNotice;
